import React from 'react'

const General_Ortho_by_dr_garlapati_sivasrikar_guntur = () => {
  return (
    <>
      <div className="container-fluid strips " id="strip" style={{ display: 'flex', backgroundColor: "#0899ff" }}>
        <div className="col text-center strip1" style={{ color: 'white' }}>
          <div className="row mt-5 mb-5" >
            <h1 style={{ textTransform: 'uppercase' }}>General Orthopedics</h1>
          </div>
        </div>
      </div>

      <div className='custom-container'>
        <div className='row mt-3 '>
          <div className='col-md-6 '>
            <h1 style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px', marginLeft: '1%' }}>General Orthopedics</h1>
            <p style={{ color: 'grey', textAlign: 'justify' }}>General Orthopedics focuses on the diagnosis, treatment, and management of conditions related to the bones, joints, muscles, ligaments, and tendons. These conditions can result from injuries, wear and tear, aging, or medical disorders affecting the musculoskeletal system.</p>
            <p style={{ color: 'grey', textAlign: 'justify' }}>At our center, comprehensive orthopedic care is provided by Dr. Garlapati Siva Srikar, who offers expert evaluation and treatment for a wide range of bone and joint conditions using modern medical techniques.</p>
            <h1 className="" style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px' }}>Diagnosis and Evaluation</h1>
            <p style={{ color: 'grey', textAlign: 'justify' }}>Proper orthopedic care begins with a detailed clinical examination and diagnostic tests, such as X-rays or other imaging studies. This helps in identifying the exact cause of pain or injury and planning the most effective treatment.</p>


          </div>
          <div className='col-md-6 service-img'>
            <img src='/General ortho.jpg.jpeg' alt=''></img>
          </div>
        </div>

        <h1 style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px', marginLeft: '1%' }}>Treatment for Common Orthopedic Conditions</h1>
        <p style={{ margin: '0.9%', color: 'grey', textAlign: 'justify' }}>General orthopedic care includes treatment for various conditions such as:</p>
        <ul>
          <li>Joint pain and stiffness</li>
          <li>Muscle and ligament injuries</li>
          <li>Arthritis and joint degeneration</li>
          <li>Minor fractures and sprains</li>
          <li>Back and neck pain</li>
        </ul>
        <h1 style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px', marginLeft: '1%' }}>Non-Surgical Treatment Options</h1>
        <p style={{ margin: '0.9%', color: 'grey', textAlign: 'justify' }}>Many orthopedic conditions can be managed with non-surgical treatments such as medications, lifestyle modifications, supportive braces, and guided rehabilitation to relieve pain and improve mobility.</p>
        <h1 style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px', marginLeft: '1%' }}>Surgical Treatment When Required</h1>
        <p style={{ margin: '0.9%', color: 'grey', textAlign: 'justify' }}>In cases where conservative treatments are not effective, advanced orthopedic surgical procedures may be recommended to restore proper joint function and relieve chronic pain.</p>
        <h1 style={{ fontSize: '20px', fontFamily: 'Roboto, sans-serif', color: '#ff8a00', fontWeight: 'bold', marginBottom: '15px', marginLeft: '1%' }}>Restoring Mobility and Quality of Life</h1>
        <p style={{ margin: '0.9%', color: 'grey', textAlign: 'justify' }}>The goal of general orthopedic care is to reduce pain, improve movement, and help patients return to their normal daily activities with better strength and comfort.</p>
      </div>

    </>
  )
}

export default General_Ortho_by_dr_garlapati_sivasrikar_guntur